<breadcrumbs
  [breadcrumbs]="[{ label: 'ADMIN', url: '/admin' }, { label: 'STREET_TYPES' }]"
></breadcrumbs>

<page-header title="STREET_TYPES"></page-header>

<app-table
  [isLoading]="isLoading"
  [totalItems]="state.get('total')"
  [totalResults]="state.get('results')"
  [itemsPerPage]="getQueryParam('page_size')"
  [rows]="state.get('data')"
  [currentPage]="getQueryParam('page')"
  (onPageChange)="handlePageChange($event)"
  (onPageSizeChange)="handlePageSizeChange($event)"
  (onSort)="handleSort($event)"
  [sort]="getQueryParam('sort')"
  [orderBy]="getQueryParam('order_by')"
  [columns]="columns"
>
  <ng-template #addonLeft>
    <div class="buttons m-0">
      <a
        [routerLink]="['create']"
        class="button is-small is-info"
        translationEditableDirective="CREATE_STREET_TYPE"
        >{{ 'CREATE_STREET_TYPE' | translate }}</a
      >
    </div>
  </ng-template>

  <ng-template #addonRight>
    <form>
      <input
        class="input is-small"
        type="text"
        (input)="handleFilterChange($event)"
        [value]="getQueryParam('keyword')"
        name="keyword"
        [placeholder]="'SEARCH' | translate"
        [translationEditableModalDirective]="['SEARCH']"
      />
    </form>
  </ng-template>

  <ng-template let-row="row" #actionsColumn>
    <alert #deleteAlert (confirm)="deleteStreetType(row.get('id'))" titleTrnKey="ARE_YOU_SURE" textTrnKey="YOU_WONT_BE_ABLE_TO_REVERT_THIS" />
    <div class="buttons m-0">
      <a
        [routerLink]="[row.get('id'), 'update']"
        class="button is-small"
        translationEditableDirective="UPDATE"
        >{{ 'UPDATE' | translate }}</a
      >
      <button
        class="button is-danger is-small"
        (click)="deleteAlert.fire()"
        translationEditableDirective="DELETE"
      >
        {{ 'DELETE' | translate }}
      </button>
    </div>
  </ng-template>
</app-table>
